import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { getLeafChildrenData } from 'timeSheet/utils';
import DifferenceRenderer from 'timeSheet/components/CellRenderers/DifferenceRenderer';

const useDifferenceColumn = () => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => {
    if (params.node?.group) {
      const groupItems = getLeafChildrenData(params.node);
      return groupItems.reduce((sum, item) => sum + (item.difference || 0), 0);
    }
    return params.data?.difference ?? null;
  }, []);

  const comparator = useCallback((valueA, valueB, nodeA, nodeB) => {
    if (nodeA?.group || nodeB?.group) {
      return 0;
    }
    const a = Number(valueA) || 0;
    const b = Number(valueB) || 0;
    return a - b;
  }, []);
  const cellRenderer = useCallback((params) => {
    if (params.node?.group) {
      return DifferenceRenderer({
        rowData: {
          difference: params.value,
          subRows: getLeafChildrenData(params.node)
        }
      });
    }

    return DifferenceRenderer({
      rowData: params.data
    });
  }, []);

  return useMemo(
    () => ({
      field: 'difference',
      headerName: t('difference'),
      width: 100,
      maxWidth: 100,
      initialHide: true,
      sortable: true,
      cellClass: 'justify-start',
      valueGetter,
      comparator,
      cellRenderer
    }),
    [t, valueGetter, comparator, cellRenderer]
  );
};

export default useDifferenceColumn;
